import httpRequests from "@httpServices"
import { BroadcastAuth } from "@/types"
import { Credential, AuthInformation } from "@/types/user"
import { ChannelAuthorizationData } from "pusher-js/types/src/core/auth/options"

const loginUrl = "/auth/login"
const logoutUrl = "/auth/logout"
const getInfoUrl = "/auth/me"
const authAdminChannelUrl = "broadcasting/auth"

export function login(params: Credential) {
  return httpRequests.post<AuthInformation>(loginUrl, params)
}

export function logout() {
  return httpRequests.post(logoutUrl)
}

export function getUserInfo() {
  return httpRequests.get<Omit<AuthInformation, "access_token">>(getInfoUrl)
}

export function authAdminChannel(body: BroadcastAuth) {
  return httpRequests.post<ChannelAuthorizationData>(authAdminChannelUrl, body)
}
